export const UPLOAD_IMAGE = `
  mutation ($uploadType: ImageUploadTypes!, $itemId: String!, $fileName: String!) {
    uploadImage(uploadType: $uploadType, itemId: $itemId, fileName: $fileName)
  }
`;

export const DELETE_IMAGE = `
  mutation ($deleteType: ImageDeleteTypes!, $itemId: String!, $fileName: String!) {
    deleteImage(deleteType: $deleteType, itemId: $itemId, fileName: $fileName)
  }
`;
